import React, {Component} from 'react';
import {connect} from 'react-redux';
import {deleteConnection, fetchConnection} from '../../../actions/connectionActions'
import SimpleModal from "../../../components/SimpleModal";
import history from "../../../history";
import Button from "@material-ui/core/Button";
import {Link as RouterLink} from "react-router-dom";
import Grid from "@material-ui/core/Grid";

class ConnectionDelete extends Component {

  componentDidMount() {
    this.props.fetchConnection(this.props.match.params.id);
  }

  renderContent() {
    if (!this.props.connection) {
      return 'Are you sure you want to delete this connection?'
    }
    return `Are you sure you want to delete the connection associated with: ${this.props.connection.physicalIssue}?`
  }

  renderActions() {
    return (
      <Grid container alignItems="center" justify="center" spacing={4} style={{ marginTop: "16px"}}>
        <Grid item>
          <Button
            color="secondary"
            variant="contained"
            onClick={() => this.props.deleteConnection(this.props.connection._id)}
          >
            Delete
          </Button>
        </Grid>
        <Grid item>
          <Button
            color="grey"
            variant="contained"
            component={RouterLink}
            to="/dashboard/admin/connections"
          >
            Cancel
          </Button>
        </Grid>
      </Grid>
    );
  }

  render() {
    return (
      <SimpleModal
        title="Delete Connection"
        content={this.renderContent()}
        onBackdropClick={() => history.push('/dashboard/admin/connections')}
        actions={this.renderActions()}
      />
    );
  };
}

const mapStateToProps = (state) => {
  return {connection: state.connections.connection};
};

export default connect(
  mapStateToProps,
  {fetchConnection, deleteConnection}
)(ConnectionDelete);